// extracted by mini-css-extract-plugin
module.exports = {"root":"EventItem_root__FGbui","date":"EventItem_date__d3VRF","meta":"EventItem_meta__1IZ9K","versusTag":"EventItem_versusTag__1ySm5"};